// WTK-815：日期筛选里存的是 'YYYY-MM-DD' 字符串（userTimeFilter 持久化、reviewReply.dateRange），
// 用的时候都按本地日期取（getFullYear / getMonth / getDate）。但 new Date('2026-10-16') 按规范是
// UTC 零点：在 UTC 以西的时区（美洲）它是本地 10-15 晚上，日期框和请求都往前错一天，
// 再经过 updateDateRange 的时区修正又错一天 —— 「Last 7 days」显示 10-15~10-21，列表却有 10-22 的评论。
// 这里把纯日期字符串按本地零点解析；Date、时间戳、带时间的字符串照旧交给 new Date。
const YMD = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseLocalYmd(value) {
  if (typeof value === "string") {
    const m = YMD.exec(value.trim());
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(value);
}
